export const forBusiness_email_features = [
	{
		icon: '✅',
		title: 'featuresData_title1',
		subtitle: 'featuresData_subtitle1',
	},
	{
		icon: '✅',
		title: 'featuresData_title2',
		subtitle: 'featuresData_subtitle2',
		subItems: [
			{
				icon: '🔹',
				item: 'featuresData_itemsFor2_item1',
			},
			{
				icon: '🔹',
				item: 'featuresData_itemsFor2_item2',
			},
			{
				icon: '🔹',
				item: 'featuresData_itemsFor2_item3',
			},
		],
	},
	{
		icon: '✅',
		title: 'featuresData_title3',
		subtitle: 'featuresData_subtitle3',
	},
	{
		icon: '✅',
		title: 'featuresData_title4',
		subtitle: 'featuresData_subtitle4',
	},
];
